import React from 'react';
import { Link } from 'react-router-dom';
import Pattern from '../components/Pattern';
import GrowthCalculator from '../components/GrowthCalculator';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

// Milestone data for the percentage staking chart
const percentStakingData = [
  { date: '12 Jun 25', runner: 'Mysteryofthesands', stake: 50.00, odds: 3.65, result: 'WON', balance: 1132.50 },
  { date: '19 Jun 25', runner: 'Pendragon', stake: 71.29, odds: 2.28, result: 'WON', balance: 1517.01 },
  { date: '26 Jun 25', runner: 'Miss Cartesian', stake: 72.19, odds: 2.34, result: 'WON', balance: 1540.44 },
  { date: '03 Jul 25', runner: 'Western Clouds', stake: 100.98, odds: 2.16, result: 'WON', balance: 2136.68 },
  { date: '10 Jul 25', runner: 'Scandinavia', stake: 100.75, odds: 2.46, result: 'WON', balance: 2162.18 },
  { date: '16 Jul 25', runner: 'Made All', stake: 115.91, odds: 2.22, result: 'WON', balance: 2459.68 },
  { date: '24 Jul 25', runner: 'Commanders Intent', stake: 116.04, odds: 2.18, result: 'WON', balance: 2457.76 },
  { date: '31 Jul 25', runner: 'Merchant', stake: 131.12, odds: 2.5, result: 'WON', balance: 2818.97 },
  { date: '07 Aug 25', runner: 'Doilookokay', stake: 119.10, odds: 3.4, result: 'WON', balance: 2667.84 },
  { date: '14 Aug 25', runner: 'Catching The Moon', stake: 98.93, odds: 1.93, result: 'WON', balance: 2070.52 },
  { date: '17 Aug 25', runner: 'Dandys Rocket', stake: 91.72, odds: 4.1, result: 'WON', balance: 2118.78 },
];

const PercentageStakingChart: React.FC = () => (
  <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-6 border border-green-200">
    <div className="px-6 py-6 bg-green-100">
      <h4 className="text-xl font-bold text-green-900 text-center">Percentage Staking Strategy: Balance Growth (5% Staking)</h4>
    </div>
    <div className="px-6 pt-6 pb-8 bg-white">
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={percentStakingData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} minTickGap={10} />
          <YAxis tick={{ fontSize: 12 }} domain={['auto', 'auto']} />
          <Tooltip content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const d = payload[0].payload;
              return (
                <div className="bg-white p-3 rounded shadow text-xs border border-gray-200">
                  <div><strong>Date:</strong> {d.date}</div>
                  <div><strong>Runner:</strong> {d.runner}</div>
                  <div><strong>Stake:</strong> £{d.stake.toFixed(2)}</div>
                  <div><strong>Odds:</strong> {d.odds}</div>
                  <div><strong>Result:</strong> {d.result}</div>
                  <div><strong>Balance:</strong> £{d.balance.toFixed(2)}</div>
                </div>
              );
            }
            return null;
          }} />
          <Line type="monotone" dataKey="balance" stroke="#059669" strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default function LandingHonest() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div style={{ background: '#a1001a', color: '#fff', fontWeight: 'bold', textAlign: 'center', padding: '0.75rem 0', letterSpacing: '1px', fontSize: '1.1rem', position: 'sticky', top: 0, zIndex: 50 }}>
        📢 EXCLUSIVE HONEST BETTING REVIEWS PROMOTION: 21 DAY FREE TRIAL
      </div>
      <div className="relative overflow-hidden">
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900">
          <div className="absolute inset-0">
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,_rgb(255_255_255_/_0.15)_1px,_transparent_0)] [background-size:24px_24px]" />
          </div>
          <div className="relative pt-6 pb-16 sm:pb-32">
            <nav className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6">
              <div className="flex items-center flex-1">
                <div className="flex items-center justify-between w-full">
                  <Link to="/">
                    <span className="sr-only">Horse Racing Oracle</span>
                    <img
                      src="/HRO-Logo-transparent-white-logo-white-text.png"
                      alt="HRO Logo"
                      className="h-12"
                    />
                  </Link>
                  <div className="flex items-center">
                    <div className="space-x-4">
                      <Link
                        to="/login"
                        className="inline-flex items-center px-4 py-2 border border-white/20 text-sm font-medium rounded-md text-white bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-white/50 transition-all duration-200"
                      >
                        Sign In
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </nav>

            <main className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
              <div className="text-center relative">
                <h1 className="relative text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl leading-tight">
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary-300 via-primary-200 to-primary-300 mb-3 leading-tight drop-shadow-lg">
                    Intelligent Horse Racing
                  </span>
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white mb-3 leading-tight drop-shadow-lg">
                    Market Analysis & Bet Placement
                  </span>
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 leading-tight drop-shadow-lg">
                    100% on Auto-Pilot
                  </span>
                </h1>
                <p className="mt-3 max-w-md mx-auto text-lg text-gray-300 sm:text-xl md:mt-10 md:text-2xl md:max-w-3xl relative z-20">
                  Betting on <b>favourites</b> with confidence has never been this easy.
                  Smart betting powered by <b>strict parameters and strong risk management</b>.
                  Identify <b>high-confidence opportunities</b> and achieve consistent, daily returns...<b><u>on auto-pilot</u></b>.
                </p>
                <div className="mt-10 max-w-md mx-auto sm:max-w-none sm:flex sm:justify-center md:mt-12 relative z-20 sm:space-x-4 space-y-4 sm:space-y-0">
                  <a
                    href="https://buy.stripe.com/aFa14n5F16Nz05feLO6kg04"
                    className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 md:py-4 md:text-lg md:px-10"
                  >
                    Start Your 21 Day Free Trial
                    <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </a>
                  <a
                    href="#what-is-hro"
                    className="inline-flex items-center justify-center px-8 py-3 rounded-md text-base font-medium text-white border border-white/20 bg-white/10 hover:bg-white/20 transition-all duration-200 md:py-4 md:text-lg md:px-10"
                  >
                    Learn More
                    <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </a>
                </div>
                <p className="mt-4 text-sm text-gray-300 text-center">
                  After 21 days, the monthly recurring membership costs £67 (billed monthly)
                </p>

                {/* Video Preview Section */}
                <div className="mt-12 max-w-3xl mx-auto px-4 sm:px-6 relative z-20">
                  <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden bg-gray-800 shadow-xl border border-white/10">
                    <video
                      className="w-full h-full object-cover"
                      src="/videos/HRO-Landing-Page.mp4"
                      poster="/youtube-banner.png"
                      controls
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>

      <div className="mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* What is Horse Racing Oracle Section */}
          <div id="what-is-hro" className="mb-24">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
              What is Horse Racing Oracle?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
                <div className="prose prose-lg max-w-none">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Horse Racing Oracle is an <span className="text-primary-600 font-semibold">intelligent automated betting bot</span> that takes the complexity out of horse race betting. Using advanced algorithms and real-time data analysis, it identifies and places bets on strong favorites with the highest probability of success.
                  </p>
                  <div className="mt-6 space-y-4">
                    <div className="flex items-start">
                      <svg className="h-6 w-6 text-green-500 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <p className="ml-3 text-gray-600">Select your staking strategy based on your risk and reward preferences (Daily Profit Target or Percentage Staking)</p>
                    </div>
                    <div className="flex items-start">
                      <svg className="h-6 w-6 text-green-500 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <p className="ml-3 text-gray-600">Bot automatically analyses and places bets</p>
                    </div>
                    <div className="flex items-start">
                      <svg className="h-6 w-6 text-green-500 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <p className="ml-3 text-gray-600">Built-in risk management and loss protection</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-sm border border-primary-100">
                  <h3 className="text-xl font-semibold text-primary-900 mb-2">Smart Analysis</h3>
                  <p className="text-gray-600">Analyses multiple factors including odds, ratings, and form data</p>
                </div>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-sm border border-primary-100">
                  <h3 className="text-xl font-semibold text-primary-900 mb-2">Auto Betting</h3>
                  <p className="text-gray-600">Places bets automatically when conditions match criteria</p>
                </div>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-sm border border-primary-100">
                  <h3 className="text-xl font-semibold text-primary-900 mb-2">Risk Control</h3>
                  <p className="text-gray-600">Implements strict stake sizing and profit targets</p>
                </div>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl shadow-sm border border-primary-100">
                  <h3 className="text-xl font-semibold text-primary-900 mb-2">24/7 Operation</h3>
                  <p className="text-gray-600">Runs continuously during active racing hours</p>
                </div>
              </div>
            </div>
          </div>

          {/* Comparison Section */}
          <div className="mt-16 max-w-7xl mx-auto px-4 sm:px-6 py-16">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
              Why Choose Horse Racing Oracle?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Manual Betting</h3>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Time-consuming research
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Emotional decisions
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Inconsistent results
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    No automation
                  </li>
                </ul>
              </div>
              <div className="bg-primary-50 p-6 rounded-lg shadow-sm border border-primary-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Horse Racing Oracle</h3>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-700">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    AI-powered analysis
                  </li>
                  <li className="flex items-center text-gray-700">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Data-driven decisions
                  </li>
                  <li className="flex items-center text-gray-700">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Consistent strategy
                  </li>
                  <li className="flex items-center text-gray-700">
                    <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Fully automated
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Tipster Services</h3>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Manual bet placement
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Human bias
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Variable quality
                  </li>
                  <li className="flex items-center text-gray-500">
                    <svg className="h-5 w-5 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Limited availability
                  </li>
                </ul>
              </div>
            </div>

            {/* Perfect For Section */}
            <div className="bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900 relative overflow-hidden rounded-3xl mt-12">
              <div className="absolute inset-0">
                <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,_rgb(255_255_255_/_0.15)_1px,_transparent_0)] [background-size:24px_24px]" />
              </div>
              <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16">
                <h3 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white text-center mb-12">Perfect For You If...</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <svg className="h-8 w-8 text-primary-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white">You Value Your Time</h4>
                      <p className="text-gray-300 mt-2">No need to spend hours analysing races - our bot does all the work while you focus on what matters to you</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <svg className="h-8 w-8 text-primary-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white">You Want Simplicity</h4>
                      <p className="text-gray-300 mt-2">Zero configuration needed - just set your daily target and let the bot handle everything else</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <svg className="h-8 w-8 text-primary-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white">You Seek Consistency</h4>
                      <p className="text-gray-300 mt-2">Access from any device and let the automated system work consistently towards your profit goals</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Features */}
          <div className="mt-0 max-w-7xl mx-auto px-4 sm:px-6 py-16">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
              Key Features
            </h2>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Qualifying Race Detection</h3>
                <p className="text-gray-500">
                  Our algorithm identifies races with optimal conditions for successful betting.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Confidence Levels</h3>
                <p className="text-gray-500">
                  Clear categorisation of opportunities as Very Strong, Strong, or Standard Favourites.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Real-time Tracking</h3>
                <p className="text-gray-500">
                  Monitor your performance with comprehensive statistics and live updates.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Betfair Integration</h3>
                <p className="text-gray-500">
                  Seamless connection with your Betfair account for automated trading.
                </p>
              </div>
            </div>
          </div>

          {/* How It Works Section */}
          <div className="mt-16 max-w-7xl mx-auto px-4 sm:px-6 py-16 bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900 relative overflow-hidden rounded-3xl">
            <div className="absolute inset-0">
              <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,_rgb(255_255_255_/_0.15)_1px,_transparent_0)] [background-size:24px_24px]" />
            </div>
            <div className="relative">
              <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white text-center mb-12">
                How It Works
              </h2>
              <div className="grid grid-cols-1 gap-8 md:grid-cols-4 relative">
                <div className="relative group">
                  <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg">
                    <span className="text-xl font-bold">1</span>
                  </div>
                  <h3 className="text-xl font-semibold text-white text-center mb-2 transition-colors duration-300 group-hover:text-primary-200">Sign Up & Connect</h3>
                  <p className="text-gray-300 text-center">
                    Create your account and connect your Betfair account securely
                  </p>
                  {/* Connector line */}
                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-primary-200 to-primary-300 transform -translate-x-4"></div>
                </div>
                <div className="relative group">
                  <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg">
                    <span className="text-xl font-bold">2</span>
                  </div>
                  <h3 className="text-xl font-semibold text-white text-center mb-2 transition-colors duration-300 group-hover:text-primary-200">Choose Your Staking Strategy</h3>
                  <p className="text-gray-300 text-center">
                    Choose based on your risk and reward preferences (Daily Profit Target or Percentage Staking)
                  </p>
                  {/* Connector line */}
                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-primary-200 to-primary-300 transform -translate-x-4"></div>
                </div>
                <div className="relative group">
                  <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg">
                    <span className="text-xl font-bold">3</span>
                  </div>
                  <h3 className="text-xl font-semibold text-white text-center mb-2 transition-colors duration-300 group-hover:text-primary-200">Activate the Bot</h3>
                  <p className="text-gray-300 text-center">
                    Let our AI analyse races and place bets automatically
                  </p>
                  {/* Connector line */}
                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-primary-200 to-primary-300 transform -translate-x-4"></div>
                </div>
                <div className="relative group">
                  <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg">
                    <span className="text-xl font-bold">4</span>
                  </div>
                  <h3 className="text-xl font-semibold text-white text-center mb-2 transition-colors duration-300 group-hover:text-primary-200">Track & Profit</h3>
                  <p className="text-gray-300 text-center">
                    Monitor your performance and withdraw profits anytime
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Section */}
          <div className="mt-16 max-w-7xl mx-auto px-4 sm:px-6 py-16">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
              Start Winning Today
            </h2>
            {/* 7-Day Trial Full Width */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-8">
              <div className="px-6 py-8 bg-primary-500 sm:p-10 sm:pb-6">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 items-center text-center">
                  <div>
                    <h3 className="text-2xl leading-9 font-extrabold text-white">
                      21-Day Trial
                    </h3>
                    <div className="mt-4 flex items-center justify-center text-white">
                      <span className="text-5xl font-extrabold">FREE</span>
                    </div>
                  </div>
                  <div className="text-white">
                    <p className="text-lg">Then only</p>
                    <p className="text-3xl font-bold">£67/month</p>
                    <p className="text-sm mt-2">Cancel anytime</p>
                  </div>
                </div>
              </div>
              <div className="px-6 pt-6 pb-8 bg-white sm:p-10">
                <ul className="space-y-4 max-w-md mx-auto text-center">
                  {[
                    'Immediate access to web app',
                    'Full access to automated betting bot',
                    'Real-time performance tracking',
                    '2 strategies to choose from',
                    'Secure Betfair integration',
                    '24/7 technical support',
                    '14-day money-back guarantee'
                  ].map((feature) => (
                    <li key={feature} className="flex items-center justify-center">
                      <div className="flex-shrink-0">
                        <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <p className="ml-3 text-base text-gray-700">{feature}</p>
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <a
                    href="https://buy.stripe.com/aFa14n5F16Nz05feLO6kg04"
                    className="w-full flex items-center justify-center px-6 py-4 border border-transparent text-xl font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 text-center"
                  >
                    Start Your 21 Day Free Trial
                  </a>
                  <p className="mt-4 text-sm text-gray-500 text-center">
                    After 21 days, the monthly recurring membership costs £67 (billed monthly)
                  </p>
                </div>
              </div>
            </div>
            {/* 2-Column Earnings Comparison */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Growth Calculator Left */}
              <div className="w-full">
                <GrowthCalculator />
              </div>
              {/* Percentage Staking Results Right */}
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col w-full border border-green-200">
                <PercentageStakingChart />
                <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 m-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Recent Results History</h4>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Bets Placed:</span>
                      <span className="text-xl font-bold text-green-700">127 (12 Jun - 17 Aug 2025)</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Win Rate:</span>
                      <span className="text-xl font-bold text-green-700">42% (54 won, 73 lost)</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Starting Balance:</span>
                      <span className="text-xl font-bold text-green-700">£1,000</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Stake per Race:</span>
                      <span className="text-xl font-bold text-green-700">5%</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Ending Balance:</span>
                      <span className="text-xl font-bold text-green-700">£2,118</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Profit:</span>
                      <span className="text-xl font-bold text-green-700">£1,118</span>
                    </div>
                    <div className="flex justify-between items-center py-3 border-b border-gray-200">
                      <span className="text-gray-600 font-medium">Return:</span>
                      <span className="text-xl font-bold text-green-700">111%</span>
                    </div>
                    <div className="flex justify-between items-center py-3">
                      <span className="text-gray-600 font-medium">ROI:</span>
                      <span className="text-xl font-bold text-green-700">48.6%</span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-500 text-center mt-4">
                    *Based on actual recent results. Past performance is not necessarily indicative of future results.
                  </p>
                  <div className="flex justify-center mt-4">
                    <a
                      href="/Percentage_Staking_Results_Tracker.xlsx"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-700 hover:text-green-900 underline font-semibold"
                    >
                      View full results here
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 bg-gray-50">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
              Frequently Asked Questions
            </h2>
            <div className="max-w-3xl mx-auto divide-y divide-gray-200">
              {[
                {
                  question: "What is HorseRacingOracle?",
                  answer: "HorseRacingOracle is an automated betting bot that uses advanced algorithms to identify and place bets on qualifying horse races. It analyses multiple factors including odds, ratings, and form to make informed betting decisions, aiming to generate consistent profits while managing risk."
                },
                {
                  question: "What is the difference between the Daily Profit Target and Percentage Staking strategies?",
                  answer: "The Daily Profit Target strategy aims to achieve a set daily profit percentage (Maximum of 2% of your balance) while the Percentage Staking strategy bets a fixed percentage of your live balance (e.g., 2% or 5%). The Daily Profit Target strategy is considered high risk and high reward, while the Percentage Staking strategy is considered low risk and low reward."
                },
                {
                  question: "Once I purchase, how will I receive access to HorseRacingOracle?",
                  answer: "After your purchase, you'll be redirected to a thank you page where you can create your account and start using HorseRacingOracle immediately."
                },
                {
                  question: "What is a daily profit target?",
                  answer: "A daily profit target is a limit you set on how much profit the bot will aim to make in a single day. This helps manage your bankroll and ensures sustainable, long-term trading. Once the daily target is reached, the bot will stop placing bets for that day."
                },
                {
                  question: "How does the bot select races to bet on?",
                  answer: "The bot analyses multiple factors including number of runners, odds, official ratings, and recent form to identify qualifying races with strong favorites."
                },
                {
                  question: "What balance amount do I need to start?",
                  answer: "In order for the bot to operate properly, we recommend a minimum starting balance of £250 for the Daily Profit Target strategy and a minimum stake per bet of £1 for the Percentage Staking strategy (as Betfair has a minimum stake of £1 per bet)."
                },
                {
                  question: "What is the maximum daily profit target?",
                  answer: "To help protect your balance and manage your funds, our system allows a maximum daily profit target of 2% of your account balance."
                },
                {
                  question: "How do I connect my Betfair account?",
                  answer: "Go to the 'Connect Betfair Account' page and follow the authentication process. You'll need to authorise our HorseRacingOracle application to place bets on your behalf."
                },
                {
                  question: "What happens if I lose internet connection?",
                  answer: "The bot will continue to run even if your internet cuts off or your computer is switched off. In the unlikely scenario where we have issues connecting to Betfair's servers then the bot will stop operating until connection is restored."
                },
                {
                  question: "Can I run the bot 24/7?",
                  answer: "Yes, the bot can run continuously, but it will only place bets during active racing hours and when qualifying races are found."
                }
              ].map((faq, index) => (
                <div key={index} className="py-6">
                  <h3 className="text-lg font-medium text-gray-900">
                    {faq.question}
                  </h3>
                  <p className="mt-2 text-base text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Call to Action Section */}
          <div className="bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900 relative overflow-hidden rounded-3xl mb-16">
            <div className="absolute inset-0">
              <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,_rgb(255_255_255_/_0.15)_1px,_transparent_0)] [background-size:24px_24px]" />
            </div>
            <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 py-24">
              <h2 className="text-4xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white mb-8">
                Ready to Start Winning?
              </h2>
              <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
                Join successful traders who are already using Horse Racing Oracle to achieve consistent returns in horse racing markets.
              </p>
              <a
                href="https://buy.stripe.com/aFa14n5F16Nz05feLO6kg04"
                className="inline-block px-8 py-4 text-xl font-semibold rounded-md bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 text-gray-900 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 transform hover:-translate-y-1 hover:shadow-xl"
              >
                Start Your 21 Day Free Trial
              </a>
              <p className="mt-4 text-sm text-gray-400">
                After 21 days, the monthly recurring membership costs £67 (billed monthly)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 